import { Model } from "./model";

export class OrderList extends Model {
    id: number;
    reference: string;
    status: string;
    notification: boolean;
    notification_key?: string;
    created: string;
    modified?: string;
    posm_subitem_thumbnail_url?: string;
}


// WEBPACK FOOTER //
// ./src/models/order-list.model.ts